import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import { HeroKicker } from '@/components/marketing/hero-kicker'
import { Button } from '@/components/ui/button'
import { getAppUrl } from '@/config/marketing-nav.config'

export function NotFoundPage() {
  useEffect(() => {
    document.title = 'Page Not Found | Podium Markets'
  }, [])

  return (
    <main className="legal-document not-found-page">
      <div className="marketing-container">
        <div className="hero-stack not-found-page__content">
          <HeroKicker>Page not found</HeroKicker>
          <h1 className="not-found-page__code">404</h1>
          <p className="not-found-page__title">
            Looks like this page missed the market.
          </p>
          <p className="not-found-page__lead">
            We couldn’t find what you were looking for. Let’s get you back on
            track.
          </p>
          <div className="not-found-page__actions">
            <Button asChild variant="cta" size="cta">
              <Link to="/" className="marketing-cta__button">
                Back to home
              </Link>
            </Button>
            <Button asChild variant="secondary" size="cta">
              <a href={getAppUrl('/login')} className="marketing-cta__button">
                Log in
              </a>
            </Button>
          </div>
        </div>
      </div>
    </main>
  )
}
